<template>
  <div>
    <v-dialog v-model="dialog" max-width="450px" width="100%">
      <v-card
        :loading="loading"
        class="mx-auto elevation-1"
        max-width="450px"
        width="100%">
        <v-img 
          class="text-white d-flex align-start"
          :src="require('@/assets/praia_ondas.jpg')"
          height="200"
          cover>
          <v-card-title class="d-flex justify-end w-100">
            <img style="height: 50px;" :src="require('@/assets/logo.png')" alt="smartsurf_logo" />
          </v-card-title>
        </v-img>
        <v-card-title>{{ $t('messages.login') }}</v-card-title>
        <v-card-text v-if="!usePhone">
          <v-form>
            <v-text-field
              v-model="user.email"
              :label="$t('messages.email')"
              name="nm-smart-login"
              prepend-inner-icon="mdi-account"
              type="text"
              variant="outlined"
            ></v-text-field>
            <v-text-field
              ref="inputPass"
              v-model="user.password"
              id="password"
              :label="$t('messages.password')"
              name="nm-smart-password"
              prepend-inner-icon="mdi-lock"
              type="password"
              @keyup.enter="login"
              variant="outlined"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-text v-if="usePhone">
          <v-form>
            <v-text-field
              v-model="user.phone"
              :label="$t('messages.phone_login_hint')"
              name="nm-smart-phone-new"
              prepend-inner-icon="mdi-phone"
              type="text"
              variant="outlined"
            ></v-text-field>
            <v-text-field
              v-model="user.token"
              id="token"
              :label="$t('messages.token')"
              name="nm-smart-token"
              prepend-inner-icon="mdi-key-variant"
              type="number"
              @keyup.enter="login"
              variant="outlined"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-text v-if="message">
          <span class="text-red">{{ message }}</span>
        </v-card-text>
        <v-card-actions class="pa-4 flex-wrap ga-2">
          <v-btn 
            variant="outlined" 
            @click="dialog = false"
            prepend-icon="mdi-close"
          >
            {{ $t('messages.close') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            variant="outlined" 
            color="warning" 
            @click="signup"
            prepend-icon="mdi-account-plus"
          >
            {{ $t('messages.register') }}
          </v-btn>
          <v-btn 
            color="primary" 
            variant="elevated"
            @click="login" 
            :disabled="!user.email || !user.password"
            prepend-icon="mdi-login"
          >
            {{ $t('messages.login') }}
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-actions class="pa-4" v-if="false">
          <v-btn 
            color="red" 
            variant="elevated"
            @click="loginWithGoogle" 
            :loading="googleLoading"
            prepend-icon="mdi-google"
            block
          >
            {{ $t('messages.continue_with_google') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import httpClient from '../../api/httpClient'
import { googleAuth } from '../../services/googleAuth'

export default {
  inject: ['bus'],
  data () {
    return {
      dialog: false,
      loading: false,
      googleLoading: false,
      usePhone: false,
      user: {},
      message: "",
    }
  },
  mounted () {
    if(this.$route.query.type === "token") {
      this.usePhone = true
    }
    
    // Load remembered email
    const rememberedEmail = localStorage.getItem('rememberedEmail')
    if (rememberedEmail) {
      this.user.email = rememberedEmail
    }
    
    this.bus.on("loginDialog", () => this.dialog = true)
    this.bus.on("loginRegisteredUser", (data) => {
      this.user.email = data.email
      setTimeout(() => {
        this.focusInputPass()
      }, 1000)
    })
  },
  methods: {
    login() {
      this.loading = true
      httpClient
        .post('/oauth/api/v1/signin', this.user)
        .then((resp) => {
          this.loading = false

          const token = resp.data.access_token || resp.data.token || resp.data.authToken
          if (token) {
            localStorage.setItem('authToken', token)
          }
          
          this.$store.commit('setUserName', resp.data.name)
          this.$store.commit('setEmail', resp.data.email)
          this.$store.commit('setProfile', resp.data.profile)
          
          // Remember email for next login
          localStorage.setItem('rememberedEmail', resp.data.email)
          
          if (token) {
            this.$store.commit('setToken', token)
          }

          this.bus.emit('loggedIn')
          this.$forceUpdate()
          this.dialog = false
          
          // Clear password field
          this.user.password = ''

          this.$router.push('/chatbot')
        })
        .catch(() => {
          this.loading = false
          this.message = this.$t('messages.wrong_email_password')
          this.bus.emit('modernSnackBarMsg', {error: true, msg: this.$t('messages.wrong_email_password')})
        })
    },
    signup() {
      this.bus.emit("signupDialog")
      this.dialog = false
    },
    focusInputPass() {
      this.$refs.inputPass.focus();
    },
    async loginWithGoogle() {
      this.googleLoading = true
      this.message = ''
      try {
        const result = await googleAuth.signIn()
        if (result.success) {
          // Send Google token to backend for validation
          const response = await httpClient.post('/oauth/api/v1/google-signin', {
            token: result.user.token
          })
          
          this.$store.commit('setUserName', response.data.name)
          this.$store.commit('setEmail', response.data.email)
          this.$store.commit('setProfile', response.data.profile)
          
          localStorage.setItem('rememberedEmail', response.data.email)
          
          const token = response.data.access_token || response.data.token || response.data.authToken
          if (token) {
            localStorage.setItem('authToken', token)
            this.$store.commit('setToken', token)
          }
          
          this.bus.emit('loggedIn')
          this.dialog = false
          this.$router.push('/chatbot')
        } else {
          this.message = result.error || this.$t('messages.google_login_failed')
        }
      } catch (error) {
        this.message = this.$t('messages.google_login_failed')
        console.error('Google login error:', error)
      } finally {
        this.googleLoading = false
      }
    }
  }
}
</script>

<style>
/* Override browser autofill background */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: black !important;
}
</style>